/**
 * Shares app-level dialog actions with download surfaces.
 *
 * 1. `requestBase` opens the singleton dialog for one caller.
 * 2. `closeOnParentUnmount` cancels only that caller's request.
 * Continues in `DownloadReasonDialogProvider.tsx`.
 */

import { createContext } from 'react';

import type { DownloadRequest } from './types';

/** Shares the singleton dialog request and caller-unmount cleanup with download surfaces. */
export type DownloadReasonDialogContextValue = {
  requestBase: (parentId: string, request: DownloadRequest) => Promise<boolean>;
  closeOnParentUnmount: (parentId: string) => void;
};

/** Holds the singleton dialog actions for the recruiter app tree. */
const DownloadReasonDialogContext = createContext<DownloadReasonDialogContextValue>({
  requestBase: (_parentId, _request) => {
    throw new Error('Missing DownloadReasonDialogProvider');
  },
  closeOnParentUnmount: (_parentId) => {
    throw new Error('Missing DownloadReasonDialogProvider');
  },
});

export default DownloadReasonDialogContext;
